import { render, staticRenderFns } from "./Collateral.vue?vue&type=template&id=61b03062&"
import script from "./Collateral.vue?vue&type=script&lang=js&"
export * from "./Collateral.vue?vue&type=script&lang=js&"
import style0 from "./Collateral.vue?vue&type=style&index=0&id=61b03062&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports